// export const googleMapsApiKey = "AIzaSyBoGl2szeBzVnyWJexC8b4OLT1OylQ1UyQ";
export const googleMapsApiKey = "AIzaSyD0GCLdMWhpD52fKpcimWMgwVQX8WzLvy0";

// Local API's
// export const host = "http://127.0.0.1:4000";
// export const BackendURL = host;
// export const galleryHost = "http://127.0.0.1:8000";
// export const orderHost = "http://127.0.0.1:5000";
// export const ticketHost = "http://127.0.0.1:4001";

// Hosted API's
export const Gatwayhost = "https://dev.api-gateway.farmershoptechindia.com";
export const host = "https://dev.api.farmershoptechindia.com";
export const BackendURL = host;
export const hostNew = host + "/employee-service/v1";
export const galleryHost = host + "/imgService";
export const orderHost = host + "/orderService";
export const ticketHost = host + "/ticketService";
const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: "/",
  defaultPath: "/",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
};

export default config;
